import deprecated from './deprecated';
import isExpired from './is-expired';
import getTargetName from './get-target-name';

export default version => {
  deprecated.forEach((keys, target) => {
    Object.keys(keys).forEach(key => {
      const options = keys[key];
      if (isExpired(version, options.version)) {
        // eslint-disable-next-line
        console.error(
          `@DEPRECATED: ${getTargetName(target)}.${key} has been deprecated. ${
            options.message
          }. Please remove.`
        );
      }
    });
  });
};
